import { Pipe, PipeTransform } from '@angular/core';
import {
    CourseParticipationStatus,
    CourseType,
    CustomerListModuleStatus,
} from '../../../../../../shared/interfaces/src';
import { NumberToNumberingPipe } from '../../../../../../../../angular/ui/pipes/src/lib/number-to-numbering.pipe';

@Pipe({ name: 'courseParticipationStatus' })
export class CourseParticipationStatusPipe implements PipeTransform {
    constructor(private numberingPipe: NumberToNumberingPipe) {}

    transform(
        status?: CustomerListModuleStatus[],
        courseType?: CourseType,
        completed = false
    ): CourseParticipationStatus {
        if (!status) {
            return null;
        }

        if (completed) {
            return CourseParticipationStatus.EDUCATION_DONE;
        }

        switch (courseType) {
            case CourseType.TrainingCourse:
                return !this.isDone(status[0])
                    ? CourseParticipationStatus.TRAINING_IN_PROGRESS
                    : CourseParticipationStatus.TRAINING_DONE;
            case CourseType.EducationCourse:
                for (const moduleStatus of status) {
                    if (!this.isDone(moduleStatus)) {
                        switch (moduleStatus.sequentialNumber) {
                            case 1:
                                return CourseParticipationStatus.EDUCATION_MODULE_1;
                            case 2:
                                return CourseParticipationStatus.EDUCATION_MODULE_2;
                            case 3:
                                return CourseParticipationStatus.EDUCATION_MODULE_3;
                            case 4:
                                return CourseParticipationStatus.EDUCATION_MODULE_4;
                        }
                    }
                }
                return CourseParticipationStatus.EDUCATION_REPETITORIUM;
            default:
                throw new Error('Unknown course type: ' + courseType);
        }
    }

    private isDone(moduleStatus: CustomerListModuleStatus): boolean {
        return moduleStatus.controlTestPassed;
    }
}
